import {
	listResourceQueryDefinitions,
	viewResourceQueryDefinitions,
	createResourceMutationDefinitions,
	updateResourceMutationDefinitions,
	deleteResourceMutationDefinitions
} from '@/providers/graphql/resourceQueryDefinitions';
import gql from 'graphql-tag';

export const GATES_LIST_QUERY = gql`
	query Terminals(
		$first: Int
		$after: String
		$where: TerminalViewModelFilterInput
		$order: [TerminalViewModelSortInput!]
	) {
		terminals(first: $first, after: $after, where: $where, order: $order) {
			nodes {
				terminalId
				name
				ipAddress
				gateKey
				isActive
				terminalTypeId
				terminalType {
					terminalTypeId
					name
				}
			}
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
		}
	}
`;

export const GATE_LIST_ITEM_QUERY = gql`
	query TerminalListItem($id: Ulid!) {
		terminal(terminalId: $id) {
			terminalId
			name
			ipAddress
			gateKey
			isActive
			terminalTypeId
			terminalType {
				terminalTypeId
				name
			}
		}
	}
`;

export const GATE_QUERY = gql`
	query Terminal($id: Ulid!) {
		terminal(terminalId: $id) {
			terminalId
			name
			ipAddress
			gateKey
			isActive
			terminalTypeId
			terminalType {
				terminalTypeId
				name
			}
		}
	}
`;

export const TERMINAL_TYPES_QUERY = gql`
	query TerminalTypes {
		terminalTypes {
			terminalTypeId
			name
		}
	}
`;

export const GATE_CREATE_MUTATION = gql`
	mutation CreateTerminal($input: CreateTerminalInput!) {
		createTerminal(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

export const GATE_UPDATE_MUTATION = gql`
	mutation UpdateTerminal($input: UpdateTerminalInput!) {
		updateTerminal(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

export const GATE_DELETE_MUTATION = gql`
	mutation DeleteTerminal($input: DeleteTerminalInput!) {
		deleteTerminal(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

listResourceQueryDefinitions['gates'] = {
	document: GATES_LIST_QUERY,
	dataPath: 'terminals.nodes',
	variables: { first: 50 }
};

viewResourceQueryDefinitions['gates'] = {
	document: GATE_QUERY,
	dataPath: 'terminal'
};

createResourceMutationDefinitions['gates'] = {
	document: GATE_CREATE_MUTATION,
	operation: 'createTerminal',
	getVariables: (variables: Record<string, unknown>) => ({ input: variables })
};

updateResourceMutationDefinitions['gates'] = {
	document: GATE_UPDATE_MUTATION,
	operation: 'updateTerminal',
	getVariables: (variables: Record<string, unknown>) => ({ input: variables })
};

deleteResourceMutationDefinitions['gates'] = {
	document: GATE_DELETE_MUTATION,
	operation: 'deleteTerminal',
	getVariables: (variables: Record<string, unknown>) => ({ input: variables })
};
